export default "__VITE_ASSET__784621a4__"